import ChartBuilder from './builder/chart-builder.js';
import ChartParams from './params/chart-params.js';


export default class ChartManager 
{

	constructor()
	{
		this.loading = false;
		
		this.last_ids = {
			chart: {id:false}
		}
	}
		

	init() 
	{
		this.cacheDom();
		this.bindBuilderEvents();
		this.initGoogleCharts();
		this.clear();
		// When packages are loaded, trigger initial input to render chart
		google.charts.setOnLoadCallback(() => this.$filters.trigger('input'));
		return this;
	}

	clear() 
	{
		$('#ajax_content').html('');

		this.$rendered_charts.remove();
		
		return this;
	}

	initGoogleCharts() 
	{
		if (typeof google != "undefined") {

			google.charts.load('current', {'packages':['corechart']});
			
			google.charts.load('current', {'packages':['table']});
		
		}
		return this;
	}

	cacheDom() 
	{
		this.$rendered_charts  = $('.chart_element');
		this.$container     = $(document).find('#analytics-container');
		this.$filters       = this.$container.find('.analytics-filters');
		this.$charts        = this.$filters.find('select[name=chart]');
		this.$chart_options = this.$charts.find('.analytics_dropdown');
		this.$types         = this.$filters.find('select[name=type]');
		return this;
	}

	startLoading() 
	{
		var $alert = $('<div>').addClass('alert')
						   .addClass('loading-alert')
						   .addClass('alert-info')
						   .html('<img src="/images/loader_50px.gif"/>&nbsp;Loading, please wait...');
		if ($('.loading-alert').length == 0) {
			$('.analytics-filters').after($alert);
		}
	}

	stopLoading() 
	{
		$('.loading-alert').remove();
	}

	refresh() 
	{
		this.$filters.trigger('input');
	}

		
	bindBuilderEvents() 
	{
		$(window).on('resize', this.onResizeWindow.bind(this));

		this.$filters.off('input').on('input', this.onCreateChart.bind(this));
		
		return this;
	}


	getNextChartId(type) 
	{
		const last_id = this.last_ids[type]['id'];
		if (!last_id) {
			return type + '_1';
		}
		return type + '_' + (this.last_ids[type]['id'] + 1);
	}


	onCreateChart(e) 
	{
		// Set the last changed dropdown eg. type or chart
		this.last_changed = e.target.name;

		e.preventDefault();

		this.clear();
		
		this.startLoading();
		
		const formdata = this.getFormData();
		const params   = new ChartParams;
		params.type    = formdata.type;
		params.id      = 'chart';
		
		params.chart_options.width = this.getContainerWidth();
		const chartBuilder = new ChartBuilder(params);
		
		chartBuilder.build(formdata.chart)
					.always(() => {
						this.stopLoading();
					})
		return this;
	}


	onResizeWindow(e) 
	{
		if (this.$filters.is(':visible') && this.loading == false) {
			this.$filters.trigger('input');
		}
		return this;	
	}


	getContainerWidth() 
	{
		return this.$container.width();
	}


	getFormData() 
	{
		return this.$filters.serializeObject();
	}

}